module.exports = __webpack_public_path__ + "img/support-icon.f2d562b2.svg";